export default {"src":"/_next/static/media/fileUploadChecked.fb39a309.svg","height":20,"width":21};